import FreeTimeExpiredModal from './FreeTimeExpiredModal';

export default FreeTimeExpiredModal;
